import { validate } from 'isemail';

// static function exported to be tested independently
export const newEmailValidation = (str: string, emails: string[]) => {
  const lCaseStr = str.toLowerCase();
  if (emails.includes(lCaseStr))
    return `Email "${str}" has already been added to the list.`;
  if (!validate(lCaseStr)) return `"${str}" is not a valid email adress`;
  return null;
};
